import { get as lodashGet } from 'lodash'
import mixpanelUtils from '@/utils/mixpanel.utils'

const { mixpanelAvailable } = mixpanelUtils

function _unregisterBlankProps(propObj) {
  Object.keys(propObj).forEach((key) => {
    if (!propObj[key]) {
      mixpanelUtils.unregister(key)
    }
  })
}

const setUserContext = (user) => {
  // TODO: set the User properties base on the new convention
  const userProps = {
    plan: user.plan,
    email: user.email,
    user_language: lodashGet(user, 'personalInformation.presenterLanguage', 'en'),
  }
  if (mixpanelAvailable) {
    mixpanelUtils.register(userProps)
    _unregisterBlankProps(userProps)
  }
}

const setPresentationContext = (presentation) => {
  // TODO: set the Presentation properties base on the new convention
  const presentationProps = {
    presentation_id: presentation.id,
    presentation_language: lodashGet(presentation, 'language', 'en'),
    // TODO: more props here
  }

  if (mixpanelAvailable) {
    mixpanelUtils.register(presentationProps)
    _unregisterBlankProps(presentationProps)
  }
}

const setSlideContext = (slide) => {
  // TODO: set the Slide properties base on the new convention
  const slideProps = {
    slide_id: slide.id,
    slide_type: slide.type,
    // TODO: more props here
  }
  if (mixpanelAvailable) {
    mixpanelUtils.register(slideProps)
    _unregisterBlankProps(slideProps)
  }
}

const setRouteContext = (route) => {
  const routeProps = {
    page_name: route.name,
  }

  if (mixpanelAvailable) {
    mixpanelUtils.register(routeProps)
    _unregisterBlankProps(routeProps)
  }
}

const setFolderContext = (folder) => {
  const folderProps = {
    folder_id: folder.selectedFolderId,
  }

  if (mixpanelAvailable) {
    mixpanelUtils.register(folderProps)
    _unregisterBlankProps(folderProps)
  }
}

const setFeatureFlagsContext = (featureFlags) => {
  if (!featureFlags) return
  Object.entries(featureFlags).forEach(([key, value]) => {
    if (value?.variant?.enabled) {
      // only track feature flags with a variant
      // to avoid overloading mixpanel with too many properties
      mixpanelUtils.register({ [key]: value?.enabled || false })
    }
  })
}

export default {
  mixpanelAvailable,
  setUserContext,
  setPresentationContext,
  setSlideContext,
  setRouteContext,
  setFolderContext,
  setFeatureFlagsContext,
}
